import React, { useState, useEffect } from "react";
import { auth, db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import "../styles/Profile.css"; // Ensure styling is applied

const Profile = () => {
  const [eligibilityData, setEligibilityData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchEligibilityData = async () => {
      const user = auth.currentUser;
      if (!user) {
        alert("Please log in first!");
        navigate("/login");
        return;
      }

      const eligibilityRef = doc(db, "eligibility", user.uid);
      const eligibilitySnap = await getDoc(eligibilityRef);

      if (eligibilitySnap.exists()) {
        setEligibilityData(eligibilitySnap.data());
      } else {
        alert("No eligibility data found. Please fill out the eligibility form.");
        navigate("/eligibility-form");
      }
      setLoading(false);
    };

    fetchEligibilityData();
  }, [navigate]);

  if (loading) return <h2>Loading...</h2>;

  return (
    <div className="profile-container">
      <h2>Your Submitted Details</h2>
      {eligibilityData ? (
        <div className="profile-card">
          <p><strong>Name:</strong> {eligibilityData.name}</p>
          <p><strong>Age:</strong> {eligibilityData.age}</p>
          <p><strong>Gender:</strong> {eligibilityData.gender}</p>
          <p><strong>Caste:</strong> {eligibilityData.caste}</p>
          <p><strong>Address:</strong> {eligibilityData.address}</p>
          <p><strong>Contact:</strong> {eligibilityData.contact}</p>
          <p><strong>Email:</strong> {eligibilityData.email}</p>
          <p><strong>Aadhar Card Number:</strong> {eligibilityData.aadhar}</p>
          <p><strong>PAN Card Number:</strong> {eligibilityData.pan}</p>
          <p><strong>Education Level:</strong> {eligibilityData.education}</p>
          <p><strong>Marital Status:</strong> {eligibilityData.maritalStatus}</p>
          <p><strong>Employment Status:</strong> {eligibilityData.employment}</p>
          <p><strong>Annual Income:</strong> {eligibilityData.income}</p>
          <p><strong>Number of Family Members:</strong> {eligibilityData.familyMembers}</p>
          <p><strong>Housing Type:</strong> {eligibilityData.housingType}</p>
          <p><strong>Disability Status:</strong> {eligibilityData.disability}</p>
        </div>
      ) : (
        <p>No eligibility data found.</p>
      )}
    </div>
  );
};

export default Profile;
